import React from 'react';

import { Grid } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import { TagFormCreate } from 'scenes/Gallery/ConversionPages/ConversionPages/TagForm';
import { loadTags } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/fields';

import { validationSchema } from './schemas';
import { TAGS } from './constants';

const ConversionPageForm = withForm({
  enableReinitialize: true,
  validationSchema: validationSchema,
})(({ loading, onClose, open, subTitle, onExited, entityId }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleAddTag = () => {
    return new Promise((resolve) => {
      openChildComponent(TagFormCreate, {
        onSubmit: async (tag) => {
          resolve(tag);
        },
      });
    });
  };

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'md'}
    >
      <SidePageV2.Title
        title={'Edit Conversion Page Tags'}
        subTitle={subTitle}
        entityId={entityId}
      />
      <SidePageV2.NewBody loading={loading}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField.MultiSelect
              label={'Tags'}
              name={TAGS}
              source={loadTags}
              addOptionLabel={'Add Tag'}
              onAdd={handleAddTag}
              padding={0}
            />
          </Grid>
        </Grid>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {childComponent}
    </SidePageV2>
  );
});

export default ConversionPageForm;
